import * as React from 'react';

interface IAvatarPlusProps {
    size : number;
    src: string;
    style? : any;
}

class AvatarPlus extends React.Component<IAvatarPlusProps, any> {

    static fallbackImage = 'https://dncam6j1wwh88.cloudfront.net/user.png';

    //noinspection JSUnusedGlobalSymbols

    static defaultProps : Partial<IAvatarPlusProps> = {
        src: AvatarPlus.fallbackImage
    };

    constructor(props : IAvatarPlusProps) {
        super(props);

        this.state = {
            img: this.props.src === null ? AvatarPlus.fallbackImage : this.props.src
        };

        this.onErrorHandler = this.onErrorHandler.bind(this);
    }

    onErrorHandler() {
        this.setState({
            img: AvatarPlus.fallbackImage
        });
    }

    render() {

        const {size} = this.props;

        return (
            <img
                src={this.state.img}
                height={size}
                width={size}
                style={{borderRadius: '50%', ...this.props.style}}
                onError={this.onErrorHandler}/>
        );

    }

}

export default AvatarPlus;


// WEBPACK FOOTER //
// ./components/common/AvatarPlus.tsx